export default "/images/668eea70364d8c7a92241a7d60e19c0f.png";